module.exports = __webpack_public_path__ + "img/hiw_icon_Upload_Census.d68dac0c.png";